"use strict";

exports.__esModule = true;
exports.FlexRowThumbnail = void 0;
var _react = _interopRequireWildcard(require("react"));
var _getNonWidgetProps = require("../../ConfigurableLayout/common/getNonWidgetProps");
var _FlexRow = require("../../Core/FlexGrid/FlexRow");
var _Measures = require("../../Measures");
var _PlantStateActivities = require("../../PlantStateActivities");
var _excluded = ["x", "y", "width", "height", "gutter", "children", "render", "backgroundColor", "backgroundColorSource", "theme"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Thumbnail for FlexRowWidget.
 */
var FlexRowThumbnail = exports.FlexRowThumbnail = /*#__PURE__*/function (_Component) {
  function FlexRowThumbnail() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(FlexRowThumbnail, _Component);
  var _proto = FlexRowThumbnail.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      x = _this$props.x,
      y = _this$props.y,
      width = _this$props.width,
      height = _this$props.height,
      gutter = _this$props.gutter,
      children = _this$props.children,
      render = _this$props.render,
      defaultBackgroundColor = _this$props.backgroundColor,
      backgroundColorSource = _this$props.backgroundColorSource,
      theme = _this$props.theme,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var backgroundColor;
    if (backgroundColorSource) {
      if (backgroundColorSource.type === "metric") {
        var thresholds = backgroundColorSource.thresholds;
        var min = thresholds[0][0];
        var max = thresholds[thresholds.length - 1][0];
        var value = min + Math.random() * (max - min);
        backgroundColor = (0, _Measures.getThresholdColor)(thresholds, value);
      } else if (backgroundColorSource.type === "cycle") {
        var plantStateColors = (0, _PlantStateActivities.getPlantStateColors)(theme);
        var stateIds = Object.keys(plantStateColors);
        backgroundColor = plantStateColors[stateIds[Math.floor(Math.random() * stateIds.length)]];
      } else {
        backgroundColor = "hotpink";
      }
    } else {
      backgroundColor = defaultBackgroundColor;
    }
    var body = children.length > 0 ? render(children) : [/*#__PURE__*/_react["default"].createElement("rect", {
      key: 1,
      fill: backgroundColor || "#fff",
      width: width,
      height: height,
      stroke: "rgba(0, 0, 0, 0.4)"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      key: 2,
      fill: backgroundColor || "#fff",
      width: width,
      height: height,
      stroke: "rgba(0, 0, 0, 0.4)"
    }), /*#__PURE__*/_react["default"].createElement("rect", {
      key: 3,
      fill: backgroundColor || "#fff",
      width: width,
      height: height,
      stroke: "rgba(0, 0, 0, 0.4)"
    })];
    var row = /*#__PURE__*/_react["default"].createElement(_FlexRow.FlexRow, _extends({
      rowComponent: "svg",
      x: x,
      y: y,
      width: width,
      height: height,
      gutter: gutter
    }, (0, _getNonWidgetProps.getNonWidgetProps)(extra)), body);
    if (backgroundColor) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("svg", {
        width: width,
        height: height,
        x: x,
        y: y
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        fill: backgroundColor,
        width: width,
        height: height
      })), row);
    }
    return row;
  };
  return FlexRowThumbnail;
}(_react.Component);
FlexRowThumbnail.defaultProps = {
  x: 0,
  y: 0,
  width: 128,
  height: 128,
  gutter: 0,
  theme: undefined
};